define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader'],
    function($, transit, modernizr, container, preloader)
    {

        return (function() {

            const model = container.getBaseModel();
            const view = container.getBaseView();
            //const pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {
            };

            model.privateVars = {
            };

            model.methods = {

            };

            /* view */

            view.publicVars = {
            };

            view.privateVars = {

            };

            view.startup = function() {
                preloader.setPreloadBulk('startup', view.publicVars.preloadTab);
            };

            view.bind = function() {
                $(view.publicVars.cssId.socialIconCls).click(function () {
                    const platform = container.getData($(this)[0], 'platform');

                    container.trackInteraction('social:' + platform + ':click', {
                        'contenttype': 'social',
                        'contenttitle': 'social ' + platform
                    });
                });
            };

            view.methods = {

            };

            /* custom events */
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function(options) {
                    model.init(options);
                    view.init(options);
                }
            };


        })();

    });